import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import store from "@/store";

export default {
    name: "CohortManagement",
    components: {
        VPagination,
    },
    data() {
        return {
            cohorts: [],
            editIndex: null,
            editableRow: null,
            protocolId: "",
            idToken: "",
            pageindex: 1,
            pageSize: 10,
            SortProperty: "cohortNumber",
            sortorder: 0,
            totalPages: 1,
            totalCount: 0,
            currentPage: 1,
            SortOrderInt: 0,
            isAscending: true,
            loadNextPage: false,
            baseurl: process.env.VUE_APP_Service_URL,
            validationErrors: {},
            protocol: {},
            isAddingNew: false,
            newRow: {
                cohortCode: "",
                cohortId: "",
                cohortName: "",
                cohortNumber: "",
                description: "",
                doseAmount: "",
                doseUnit: "",
                doseRoute: "",
                doseFrequency: "",
                doseFormulation: "",
            },
            newRowErrors: {},
        };
    },
    async mounted() {
        this.idToken = store.getters.getIdToken;
        this.protocolId = this.$route.query.id;
        await this.getProtocolbyId();
        if (this.protocolId) {
            await this.listCohorts(this.protocolId);
        }
    },
    methods: {
        SortSelected(sortProp) {
            if (this.SortProperty === sortProp) {
                this.isAscending = !this.isAscending;
            } else {
                this.SortProperty = sortProp;
                this.isAscending = true;
            }

            this.sortorder = this.isAscending ? 0 : 1;
            this.SortOrderInt = this.sortorder;

            this.pageindex = 1;
            this.currentPage = 1;

            this.listCohorts(this.protocolId);
        },
        async listCohorts(protocolId) {
            await axios
                .get(
                    `${this.baseurl}/management/studyprotocol/listdacohorts?protocolId=${this.protocolId}&pageindex=${this.pageindex}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.sortorder}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idToken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.cohorts = res.data.results;
                    this.totalCount = res.data.totalCount;
                    this.totalPages = Math.ceil(res.data.totalCount / this.pageSize);
                })
                .catch((err) => console.log("Error in fetching cohorts:", err));
        },
        editRow(index, cohort) {
            this.editIndex = index;

            this.editableRow = {
                ...cohort,

                daCohortId: cohort.id,
                cohortId: cohort.cohortId,

                doseAmount:
                    cohort.dose && cohort.dose.amount != null
                        ? cohort.dose.amount
                        : "",

                doseUnit:
                    cohort.dose && cohort.dose.unit != null
                        ? cohort.dose.unit
                        : "",

                doseRoute:
                    cohort.dose && cohort.dose.route != null
                        ? cohort.dose.route
                        : "",

                doseFrequency:
                    cohort.dose && cohort.dose.frequency != null
                        ? cohort.dose.frequency
                        : "",

                doseFormulation:
                    cohort.dose && cohort.dose.formulation != null
                        ? cohort.dose.formulation
                        : "",
            };

            this.validationErrors = {};
        },
        validateRow() {
            this.validationErrors = {};
            if (!this.editableRow.cohortCode) {
                this.validationErrors.cohortCode = "Cohort Code is required.";
            }
            if (!this.editableRow.cohortName) {
                this.validationErrors.cohortName = "Cohort Name is required.";
            }
            if (!this.editableRow.cohortName) {
                this.validationErrors.cohortName = "Cohort Name is required.";
            }
            if (!this.editableRow.cohortId) {
                this.validationErrors.cohortId = "Cohort ID is required.";
            }

            return Object.keys(this.validationErrors).length === 0;
        },
        async updateRow(cohortId) {
            try {
                if (!this.editableRow) {
                    console.error("No editable row found.");
                    return;
                }

                if (!this.validateRow()) {
                    return;
                }

                const updateData = {
                    daCohortId: cohortId, 
                    protocolRefId: this.protocolId,
                    studyId: this.editableRow.studyId || "",
                    cohortId: this.editableRow.cohortId || "",
                    cohortCode: this.editableRow.cohortCode,
                    cohortName: this.editableRow.cohortName,
                    cohortNumber: Number(this.editableRow.cohortNumber),
                    description: this.editableRow.description,
                    soaId: this.editableRow.soaId || "",
                    dose: {
                        amount: Number(this.editableRow.doseAmount) || 0,
                        unit: this.editableRow.doseUnit,
                        route: this.editableRow.doseRoute,
                        frequency: this.editableRow.doseFrequency,
                        formulation: this.editableRow.doseFormulation,
                    },
                };

                const response = await axios.put(
                    `${this.baseurl}/management/studyprotocol/updatedacohort`,
                    updateData,
                    {
                        headers: {
                            Authorization: `Bearer ${this.idToken}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("Update response:", response.data);

                this.cancelEdit();
                await this.getProtocolbyId();
                await this.listCohorts(this.protocolId);

                alert("Cohort details updated successfully.");
            } catch (err) {
                console.error("Error during updateRow API call:", err);
                alert("Failed to update cohort. Please try again.");
            }
        },
        cancelEdit() {
            this.editIndex = null;
            this.editableRow = null;
        },
        clearFieldError(fieldName) {
            if (this.validationErrors[fieldName]) {
                delete this.validationErrors[fieldName];
            }
        },
        async loadPage(page) {
            this.currentPage = page;
            this.pageindex = page;
            this.loadNextPage = true;
            await this.listCohorts(this.protocolId);
        },
        async deleteRow(cohortId) {
            try {
                const confirmation = confirm(
                    "Are you sure you want to delete this cohort?"
                );

                if (!confirmation) {
                    return;
                }

                const response = await axios.delete(
                    `${this.baseurl}/management/studyprotocol/deletebyid?collectionName=DaScrape_Cohort&id=${cohortId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${this.idToken}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("Delete response:", response.data);

                await this.listCohorts(this.protocolId);

                if (this.cohorts.length === 0 && this.currentPage > 1) {
                    this.currentPage--;
                    this.pageindex = this.currentPage;
                    await this.listCohorts(this.protocolId);
                }

                alert("Cohort deleted successfully.");
            } catch (error) {
                console.error("Error during cohort delete API call:", error);
                alert("Failed to delete the cohort. Please try again.");
            }
        },
        async getProtocolbyId() {
            const token = store.getters.getIdToken;
            await axios
                .get(
                    `${this.baseurl}/management/document/getprotocolbyid?protocolId=${this.protocolId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.protocol = res.data;
                })
                .catch((err) => console.log("error in get protocol by id", err));
        },
        addNewRow() {
            this.isAddingNew = true;
            this.newRow = {
                cohortCode: "",
                cohortId: "",
                cohortName: "",
                cohortNumber: "",
                description: "",
                doseAmount: "",
                doseUnit: "",
                doseRoute: "",
                doseFrequency: "",
                doseFormulation: "",
                soaId: "",
            };
            this.newRowErrors = {};
            // Cancel any active inline edit
            this.editIndex = null;
            this.editableRow = null;
        },

        cancelNewRow() {
            this.isAddingNew = false;
            this.newRowErrors = {};
        },

        clearNewFieldError(fieldName) {
            if (this.newRowErrors[fieldName]) {
                delete this.newRowErrors[fieldName];
            }
        },

        validateNewRow() {
            this.newRowErrors = {};
            if (!this.newRow.cohortCode) {
                this.newRowErrors.cohortCode = "Cohort Code is required.";
            }
            if (!this.newRow.cohortName) {
                this.newRowErrors.cohortName = "Cohort Name is required.";
            }

            return Object.keys(this.newRowErrors).length === 0;
        },

        async saveNewRow() {
            if (!this.validateNewRow()) return;

            try {
                const payload = {
                    collectionName: "DaScrape_Cohort",
                    data: {
                        protocolRefId: this.protocolId,
                        cohortCode: this.newRow.cohortCode,
                        cohortId: this.newRow.cohortId,
                        studyId: this.protocol.studyId,
                        cohortName: this.newRow.cohortName,
                        cohortNumber: Number(this.newRow.cohortNumber),
                        description: this.newRow.description,
                        soaId: this.newRow.soaId,
                        dose: {
                            amount: Number(this.newRow.doseAmount) || 0,
                            unit: this.newRow.doseUnit,
                            route: this.newRow.doseRoute,
                            frequency: this.newRow.doseFrequency,
                            formulation: this.newRow.doseFormulation,
                        },
                    },
                };

                await axios.post(
                    `${this.baseurl}/management/studyprotocol/genericinsert`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${this.idToken}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.isAddingNew = false;
                this.newRowErrors = {};

                await this.listCohorts(this.protocolId);

                alert("Cohort created successfully.");
            } catch (err) {
                console.error("Error creating cohort:", err);
                alert("Failed to create cohort. Please try again.");
            }
        }
    },
};